export function formatLocation(path: string | string[]) {
    if (!Array.isArray(path)) {
        return path;
    }

    const formattedLocation = path.slice(1);

    return formattedLocation.join('/');
}
